import * as React from "react";
import { StringUtils } from "abweb/utils/StringUtils";
export class SanitizedString extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.text !== this.props.text;
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.props.className,
      dangerouslySetInnerHTML: {
        __html: StringUtils.sanitizeHtmlString(this.props.text)
      }
    });
  }
}
//# sourceMappingURL=SanitizedString.js.map
